'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useResize;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultThrottleRate = 200; /* eslint-env browser */

function debounce(fn, ms) {
  var timer = void 0;

  return function () {
    clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      fn();
    }, ms);
  };
}

function useResize(handler) {
  var throttleRate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultThrottleRate;

  _react2.default.useEffect(function () {
    var debouncedHandleResize = debounce(handler, throttleRate);

    window.addEventListener('resize', debouncedHandleResize);

    return function () {
      window.removeEventListener('resize', debouncedHandleResize);
    };
  });
}